class GlassGelAcknowledgement extends HTMLElement {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInvalid = this.handleInvalid.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.input = this.querySelector('.glass-gel-acknowledgement__input');
    this.error = this.querySelector('.glass-gel-acknowledgement__error');
    this.form = this.input?.form;

    if (!this.input || !this.form) return;

    this.dataset.initialized = 'true';
    this.input.addEventListener('change', this.handleChange);
    this.input.addEventListener('invalid', this.handleInvalid);
    this.form.addEventListener('submit', this.handleSubmit, true);
  }

  disconnectedCallback() {
    if (!this.input || !this.form) return;

    this.input.removeEventListener('change', this.handleChange);
    this.input.removeEventListener('invalid', this.handleInvalid);
    this.form.removeEventListener('submit', this.handleSubmit, true);
  }

  get message() {
    return this.dataset.errorMessage || 'Please confirm before checking out.';
  }

  showError() {
    this.input.setCustomValidity(this.message);
    this.input.setAttribute('aria-invalid', 'true');
    this.error.textContent = this.message;
    this.error.hidden = false;
  }

  clearError() {
    this.input.setCustomValidity('');
    this.input.removeAttribute('aria-invalid');
    this.error.textContent = '';
    this.error.hidden = true;
  }

  handleInvalid() {
    this.showError();
  }

  handleSubmit(event) {
    if (this.input.checked) {
      this.clearError();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    this.showError();
    this.input.reportValidity();
    this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.input.focus({ preventScroll: true });
  }

  handleChange() {
    if (this.input.checked) {
      this.clearError();
    } else {
      this.showError();
    }

    const value = this.input.checked ? 'Confirmed' : '';
    document.querySelectorAll('.glass-gel-acknowledgement__input').forEach((input) => {
      input.checked = this.input.checked;
    });

    fetch(FoxTheme.routes.cart_update_url, {
      ...FoxTheme.utils.fetchConfig(),
      body: JSON.stringify({
        attributes: {
          'Glass GEL professional acknowledgement': value,
        },
      }),
    }).catch((error) => {
      console.error('Unable to save the Glass GEL acknowledgement:', error);
    });
  }
}

if (!customElements.get('glass-gel-acknowledgement')) {
  customElements.define('glass-gel-acknowledgement', GlassGelAcknowledgement);
}
